import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const PaymentMethodCard = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [saved, setSaved] = useState(false);

  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const savedInvoice = JSON.parse(localStorage.getItem('invoicePaymentInfo') || '{}');

  const [form, setForm] = useState({
    fullName: savedInvoice?.fullName || user?.name || '',
    email: savedInvoice?.email || user?.email || '',
    phone: savedInvoice?.phone || '',
    address: savedInvoice?.address || '',
    postalCode: savedInvoice?.postalCode || '',
    city: savedInvoice?.city || user?.city || '',
    country: savedInvoice?.country || user?.country || 'Norge',
    invoiceDelivery: savedInvoice?.invoiceDelivery || 'email',
  });

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e?.target?.value }));
  };

  const handleSave = () => {
    localStorage.setItem('invoicePaymentInfo', JSON.stringify(form));
    setSaved(true);
    setIsEditing(false);
    setTimeout(() => setSaved(false), 3000);
  };

  const handleCancel = () => {
    const existing = JSON.parse(localStorage.getItem('invoicePaymentInfo') || '{}');
    setForm({
      fullName: existing?.fullName || user?.name || '',
      email: existing?.email || user?.email || '',
      phone: existing?.phone || '',
      address: existing?.address || '',
      postalCode: existing?.postalCode || '',
      city: existing?.city || user?.city || '',
      country: existing?.country || user?.country || 'Norge',
      invoiceDelivery: existing?.invoiceDelivery || 'email',
    });
    setIsEditing(false);
  };

  const hasInfo = form?.fullName || form?.email || form?.address;

  return (
    <div className="card">
      <div className="flex items-start justify-between mb-6">
        <div className="flex items-center gap-3">
          <div
            className="w-12 h-12 md:w-14 md:h-14 rounded flex items-center justify-center"
            style={{ background: 'rgba(0, 79, 152, 0.1)' }}
          >
            <Icon name="FileText" size={24} color="var(--color-primary)" />
          </div>
          <div>
            <h3 className="text-base md:text-lg font-semibold text-foreground mb-1">
              Fakturainformasjon
            </h3>
            <p className="text-xs md:text-sm text-muted-foreground font-caption">
              Betalingsmetode: Faktura
            </p>
          </div>
        </div>
        {!isEditing && (
          <Button
            variant="ghost"
            size="sm"
            iconName="Edit2"
            iconSize={16}
            onClick={() => setIsEditing(true)}
          >
            Rediger
          </Button>
        )}
      </div>
      {saved && (
        <div
          className="flex items-center gap-2 px-4 py-3 rounded border-2 mb-4"
          style={{ borderColor: 'var(--color-success)', background: 'rgba(16, 185, 129, 0.1)' }}
        >
          <Icon name="Check" size={16} color="var(--color-success)" />
          <span className="text-sm font-medium" style={{ color: 'var(--color-success)' }}>
            Fakturainformasjon lagret
          </span>
        </div>
      )}
      {!isEditing ? (
        <div className="space-y-4">
          {hasInfo ? (
            <>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="p-4 rounded border-2 border-border bg-muted">
                  <span className="text-xs text-muted-foreground font-caption block mb-1">Fullt navn</span>
                  <p className="text-sm md:text-base font-medium text-foreground">{form?.fullName || '—'}</p>
                </div>
                <div className="p-4 rounded border-2 border-border bg-muted">
                  <span className="text-xs text-muted-foreground font-caption block mb-1">E-post</span>
                  <p className="text-sm md:text-base font-medium text-foreground">{form?.email || '—'}</p>
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="p-4 rounded border-2 border-border bg-muted">
                  <span className="text-xs text-muted-foreground font-caption block mb-1">Telefon</span>
                  <p className="text-sm md:text-base font-medium text-foreground">{form?.phone || '—'}</p>
                </div>
                <div className="p-4 rounded border-2 border-border bg-muted">
                  <span className="text-xs text-muted-foreground font-caption block mb-1">Land</span>
                  <p className="text-sm md:text-base font-medium text-foreground">{form?.country || '—'}</p>
                </div>
              </div>
              <div className="p-4 rounded border-2 border-border bg-muted">
                <span className="text-xs text-muted-foreground font-caption block mb-1">Adresse</span>
                <p className="text-sm md:text-base font-medium text-foreground">
                  {form?.address ? `${form?.address}, ${form?.postalCode} ${form?.city}` : '—'}
                </p>
              </div>
              <div className="p-4 rounded border-2 border-border bg-muted">
                <span className="text-xs text-muted-foreground font-caption block mb-1">Fakturalevering</span>
                <p className="text-sm md:text-base font-medium text-foreground capitalize">
                  {form?.invoiceDelivery === 'email' ? 'E-post' : form?.invoiceDelivery === 'post' ? 'Post' : 'E-post og post'}
                </p>
              </div>
            </>
          ) : (
            <div className="p-6 rounded border-2 border-dashed border-border text-center">
              <Icon name="FileText" size={32} color="var(--color-muted-foreground)" className="mx-auto mb-3" />
              <p className="text-sm text-muted-foreground font-caption mb-4">
                Ingen fakturainformasjon registrert ennå
              </p>
              <Button variant="outline" size="sm" onClick={() => setIsEditing(true)}>
                Legg til fakturainformasjon
              </Button>
            </div>
          )}
        </div>
      ) : (
        <div className="space-y-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <Input
              label="Fullt navn"
              type="text"
              placeholder="Ola Nordmann"
              value={form?.fullName}
              onChange={handleChange('fullName')}
            />
            <Input
              label="E-postadresse"
              type="email"
              placeholder="ola@eksempel.no"
              value={form?.email}
              onChange={handleChange('email')}
            />
          </div>
          <Input
            label="Telefonnummer"
            type="tel"
            placeholder="+47 000 00 000"
            value={form?.phone}
            onChange={handleChange('phone')}
          />
          <Input
            label="Gateadresse"
            type="text"
            placeholder="Storgata 1"
            value={form?.address}
            onChange={handleChange('address')}
          />
          <div className="grid grid-cols-2 gap-4">
            <Input
              label="Postnummer"
              type="text"
              placeholder="0001"
              value={form?.postalCode}
              onChange={handleChange('postalCode')}
              maxLength={4}
            />
            <Input
              label="By"
              type="text"
              placeholder="Oslo"
              value={form?.city}
              onChange={handleChange('city')}
            />
          </div>
          <Input
            label="Land"
            type="text"
            placeholder="Norge"
            value={form?.country}
            onChange={handleChange('country')}
          />

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">Fakturalevering</label>
            <div className="flex flex-col sm:flex-row gap-3">
              {[
                { value: 'email', label: 'E-post' },
                { value: 'post', label: 'Post' },
                { value: 'both', label: 'Begge' },
              ]?.map((opt) => (
                <button
                  key={opt?.value}
                  type="button"
                  onClick={() => setForm((prev) => ({ ...prev, invoiceDelivery: opt?.value }))}
                  className={`flex-1 py-3 px-4 rounded border-2 text-sm font-medium transition-colors ${
                    form?.invoiceDelivery === opt?.value
                      ? 'border-primary text-primary' :'border-border text-muted-foreground hover:border-primary/50'
                  }`}
                  style={form?.invoiceDelivery === opt?.value ? { background: 'rgba(0,79,152,0.08)' } : {}}
                >
                  {opt?.label}
                </button>
              ))}
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 pt-4">
            <Button variant="default" size="default" onClick={handleSave} className="flex-1">
              Lagre endringer
            </Button>
            <Button variant="outline" size="default" onClick={handleCancel} className="flex-1">
              Avbryt
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentMethodCard;